<template>
  <div class="create-gym-client">
    <Header />
    <Main>
      <h3 class="text-center">
        Добавление клиента спортзала "{{ gymName.toUpperCase() }}"
      </h3>
      <b-overlay :show="loading">
        <gym-client-form
          v-model="gymClientData"
          class="create-gym-client__form"
          :prices="gymPrices"
          :unions-discounts="gymUnionsDiscounts"
        />
      </b-overlay>
      <bottom-overlay v-if="edited">
        <b-button
          @click="createGymClient"
          block
          squared
          variant="success"
          class="create-gym-client__create-button"
          :disabled="loading"
        >
          Добавить клиента спортзала
        </b-button>
      </bottom-overlay>
    </Main>
  </div>
</template>
<script>
import Main from "@/components/Layout/Main";
import gymRightsMixin from "@/views/Gyms/mixins/gymRightsMixin";
import GymClientForm from "@/components/Forms/Gym/Client/GymClientAdderForm";
import BottomOverlay from "@/components/BottomOverlay";
import GymClientModel from "@/components/Forms/Gym/Client/models/gymClientModel";
import store from "@/store";
import { mapGetters } from "vuex";
import axios from "@/axios";
import pageTitleMixin from "@/mixins/pageTitleMixin";
import Header from "@/components/Layout/Header";
export default {
  mixins: [gymRightsMixin, pageTitleMixin],
  components: { Header, BottomOverlay, GymClientForm, Main },
  props: {
    gymId: {
      type: Number,
      required: true
    }
  },
  data() {
    let gymClientData = new GymClientModel();
    gymClientData.gym_id = this.gymId;
    return {
      gymClientData,
      gymPrices: [],
      gymUnionsDiscounts: [],
      loading: false
    };
  },
  computed: {
    ...mapGetters("gyms", ["gyms"]),
    gym: ({ gyms, gymId }) =>
      gyms.find(({ id }) => Number(id) === Number(gymId)),
    gymName: ({ gym }) => (gym !== undefined ? gym.name : ""),
    edited: ({ gymClientData, gymId }) =>
      JSON.stringify(gymClientData) !==
      JSON.stringify({
        ...new GymClientModel(),
        gym_id: gymId
      })
  },
  methods: {
    createGymClient() {
      this.loading = true;
      this.axios
        .post(`/gyms/clients`, this.gymClientData)
        .then(res => {
          let date = new Date();
          this.$router.push(
            `/gyms/${
              res.data.gym_client.gym_id
            }/month/${date.getFullYear()}/${date.getMonth() + 1}`
          );
        })
        .catch(() => (this.loading = false));
    }
  },
  async created() {
    this.gymPrices = (
      await axios.get(`/gyms/${this.gymId}/prices`)
    ).data.gym_prices;
    this.gymUnionsDiscounts = (
      await axios.get(`/gyms/${this.gymId}/discounts/unions`)
    ).data.union_gym_discounts;
  },
  async beforeRouteEnter(to, from, next) {
    if (!store.getters["gyms/loaded"]) await store.dispatch("gyms/loadGyms");
    if (
      store.getters["gyms/gyms"].some(
        ({ id }) => Number(id) === Number(to.params.gymId)
      )
    )
      next();
    else next("/404");
  }
};
</script>

<style lang="scss">
.create-gym-client {
  &__form {
    padding: 5px;
  }
  &__create-button {
    height: 50px;
  }
}
</style>
